<div class="trend-card" [ngClass]="scoreClass">
  <!-- Always-visible header -->
  <div class="trend-card__header">
    <div class="trend-card__meta">
      <span class="trend-card__name mds-text--medium-bold">{{ data.kpiName }}</span>
      <span class="trend-card__description mds-text--x-small-normal mds-neutral--weak__text-color">{{ data.kpiDescription }}</span>
    </div>
    <div class="trend-card__score-block">
      <div class="trend-card__value-wrapper">
        <span class="trend-card__main-value" [ngClass]="scoreClass + '-text'">
          {{ mainValue !== null ? mainValue : '—' }}{{ mainValue !== null && data.kpiUnit && data.kpiUnit !== 'none' ? ' ' + data.kpiUnit : '' }}
        </span>
        <span class="trend-card__score-label mds-text--x-small-normal mds-neutral--weak__text-color">
          {{ currentScore !== null ? 'Score: ' + currentScore + '/' + maxScore : 'Score: —' }}
        </span>
      </div>
      <button
        type="button"
        class="trend-card__toggle"
        (click)="toggle()"
        [attr.aria-expanded]="isExpanded()"
        aria-label="Toggle KPI details">
        <mc-icon [attr.icon]="isExpanded() ? 'chevron-up' : 'chevron-down'" size="20"></mc-icon>
      </button>
    </div>
  </div>

  <!-- Score progress bar -->
  <div class="trend-card__progress-bar">
    <div class="trend-card__progress-fill" [ngClass]="scoreClass + '-fill'" [style.width]="progressWidth"></div>
  </div>

  <!-- Expanded body: legend + chart + footer -->
  @if (isExpanded()) {
    <div class="trend-card__body">
      <div class="trend-card__legend-row">
        <div class="trend-card__legend-left mds-text--x-small-normal mds-neutral--weak__text-color">
          <mc-icon icon="clock" size="20"></mc-icon>
          <span>{{ isWeekly ? 'Last 8 Weeks' : 'Last 8 Months' }}</span>
          <span class="trend-card__legend-swatch" [ngClass]="scoreClass + '-swatch'"></span>
          <span class="mds-neutral__text-color">Current</span>
          <span class="trend-card__legend-swatch trend-card__legend-swatch--prior"></span>
          <span>{{ isWeekly ? 'Prior Year Week' : 'Prior Year' }}</span>
        </div>
        <span class="trend-card__trend-badge mds-text--x-small-bold" [ngClass]="'trend-badge--' + trendDirection">
          {{ trendLabel }}
        </span>
      </div>

      <div class="trend-card__chart-container">
        <canvas #trendChart></canvas>
      </div>

      <div class="trend-card__footer mds-text--x-small-normal mds-neutral--weak__text-color">
        <mc-icon icon="check-circle" size="20"></mc-icon>
        <span>{{ data.footerText }}</span>
      </div>
    </div>
  }
</div>
